import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import React from 'react';

import { heroVariantPropType } from '@/constants/propTypes';

import CategoryHeroVariant from './lib/CategoryHeroVariant';
import DefaultHero from './lib/DefaultHero';
import DirectRequestHero from './lib/DirectRequestHero';

const HeatingAssistant = dynamic(() =>
  import('@/components/HeatingAssistant/HeatingAssistant')
);

const CraneWizard = dynamic(() =>
  import('@/components/CraneWizard/CraneWizard')
);

const getFormComponent = formType => {
  switch (formType) {
    case 'heating_form':
      return <HeatingAssistant />;
    case 'crane_wizard':
      return <CraneWizard />;
    default:
      return null;
  }
};

/**
 * CategoryHero section. Content is set through strapi.
 */
const CategoryHero = ({ headline, pictures, formType, variant }) => {
  if (variant === 'category_page') {
    return <CategoryHeroVariant headline={headline} pictures={pictures} />;
  }

  if (formType === 'direct_request_form') {
    return <DirectRequestHero headline={headline} pictures={pictures} />;
  }

  return (
    <DefaultHero
      headline={headline}
      pictures={pictures}
      formComponent={getFormComponent(formType)}
    />
  );
};

CategoryHero.propTypes = {
  /** Displayed headline */
  headline: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element,
  ]).isRequired,
  /** Object with image url and properties */
  pictures: PropTypes.object,
  /** Type of form to be displayed */
  formType: PropTypes.string.isRequired,
  variant: heroVariantPropType,
};

CategoryHero.defaultProps = {
  pictures: null,
  variant: null,
};

export default CategoryHero;
